<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="学生名字">
              <a-input placeholder="请输入学生名字" v-model="queryParam.studentName"></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="8" :lg="7" :md="8" :sm="24">
            <a-form-item label="时间范围">
              <a-range-picker :value="rangeDate" @change="onRangeChange" />
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls('学生提醒数据分析')">
        导出
      </a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>
        已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>
        项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      ></a-table>
    </div>
    <!-- table区域-end -->
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import moment from 'moment'

export default {
  name: 'StatisticStudentWarnList',
  mixins: [JeecgListMixin],
  data() {
    return {
      description: '学生提醒数据分析管理页面',
      rangeDate: [],
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '年级名称',
          align: 'center',
          dataIndex: 'gradeName',
        },

        {
          title: '班级名称',
          align: 'center',
          dataIndex: 'className',
        },
        {
          title: '学生名字',
          align: 'center',
          dataIndex: 'studentName',
        },

        {
          title: '本期情绪指数',
          align: 'center',
          dataIndex: 'personHappyRate',
        },
        {
          title: '往期情绪指数',
          align: 'center',
          dataIndex: 'historyHappyRate',
        },
        {
          title: '班级情绪趋势',
          align: 'center',
          dataIndex: 'classHappyRate',
        },
        {
          title: '年级情绪趋势',
          align: 'center',
          dataIndex: 'gradeHappyRate',
        },
        {
          title: '是否关爱名单',
          align: 'center',
          dataIndex: 'careList',
          customRender: function (t, r, index) {
            return t === 0 ? '否' : '是'
          },
        },
        {
          title: '提醒时间',
          align: 'center',
          dataIndex: 'createTime',
        },
      ],
      url: {
        list: '/aigoes/statisticStudentWarn/list',
        exportXlsUrl: 'aigoes/statisticStudentWarn/exportXlsDemo',
      },
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  created() {
    this.rangeDate = [moment().subtract(14, 'days'), moment().subtract(1, 'days')]
    this.queryParam.beginDateStr = moment().subtract(14, 'days').format('YYYY-MM-DD')
    this.queryParam.endDateStr = moment().subtract(1, 'days').format('YYYY-MM-DD')

    this.loadData()
    console.log(
      '开始时间--',
      this.queryParam.beginDateStr,
      '结束时间--',
      this.queryParam.endDateStr
    )
  },
  methods: {
    onRangeChange(dates, dateString) {
      this.rangeDate = dates

      this.queryParam.beginDateStr = dateString[0]
      this.queryParam.endDateStr = dateString[1]

      this.searchQuery()
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
